module.exports = __webpack_public_path__ + "media/integrations/mobileallintegrations-460d8cb2.svg";